var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"small-caps"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }